import {
  type EventParticipantRole,
  type ProgramEventInvitee,
  type ProgramEventInviteeRole,
  isRegisteredProgramInvitee,
} from 'models';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { message } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { useGetUserNameWithFallback } from 'features/users/hooks/useGetUserNameWithFallback';
import { useGetEventRoleKey } from '../../../../hooks';
import { useUpdateEventInviteeRole as useUpdateEventInviteeRoleMutation } from '../../../../queries';

export const useUpdateEventInviteeRole = () => {
  const { t } = useTranslation();
  const { isPending: isLoadingChangingRole, mutateAsync: updateEventInviteeRole } = useUpdateEventInviteeRoleMutation();
  const getRoleName = useGetEventRoleKey();
  const getUserName = useGetUserNameWithFallback();

  const updateRole = useCallback(
    async ({
      eventId,
      invitee,
      role,
    }: {
      eventId: string;
      invitee: ProgramEventInvitee;
      role: EventParticipantRole | ProgramEventInviteeRole;
    }) => {
      // TODO: Find place for this
      const userFullNameOrEmail = isRegisteredProgramInvitee(invitee) ? getUserName(invitee) : invitee.email;

      return updateEventInviteeRole(
        {
          emailInvitees: isRegisteredProgramInvitee(invitee) ? [] : [{ ...invitee, eventRole: role }],
          eventId,
          invitees: isRegisteredProgramInvitee(invitee) ? [{ ...invitee, eventRole: role }] : [],
        },
        {
          onError() {
            message.error(
              t('Something went wrong. {{name}}’s role couldn’t be changed.', {
                name: userFullNameOrEmail,
              }),
            );
          },
          onSuccess() {
            message.success(
              t('{{name}}’s role changed to {{role}}', {
                name: userFullNameOrEmail,
                role: getRoleName({ role }),
              }),
            );
          },
        },
      );
    },
    [getRoleName, t, updateEventInviteeRole, getUserName],
  );

  return useMemo(() => ({ isLoadingChangingRole, updateRole }), [isLoadingChangingRole, updateRole]);
};
